import React, { useState, useEffect } from 'react';
import './Color.scss';
import PersonalizationContainer from '../../containers/PersonalizationContainer';
import NavigationBar from '../NavigationBar';
import { withRouter } from 'react-router-dom';
import bem from '../../utils/bem';
import Entrega from './Entrega';
import Radium, { StyleRoot } from 'radium';
import { fadeIn } from 'react-animations';
import { ANIMATIONS } from '../../utils/constants';

const ColorsList = ({personalization, colors, color, setColor, styles, className = ''}) => {
    if (personalization.isLoading) 
        return null;
    
    const defaultUrl = color?.imageGrande || personalization?.data?.imagenGrande;
    return (
        <div className={`color-list-container ${className}`}>
            <h4>Color Exterior</h4>
            <div className="flex">
                <div className="color-list">
                    {!personalization.isLoading && colors.map(pColor => {
                        return (
                            <button className={bem('color-options--color', {
                                active: pColor.codigo === color.codigo
                            })} 
                            onClick={() => {
                                setColor(pColor);
                            }}
                            style={styles.fadeIn}
                            key={pColor.codigo}>
                                <span className="hex" style={{backgroundColor: `#${pColor.codigoHex}`}}>
                                    {!!pColor.codigoHex2 && <span style={{'--flag': `#${pColor.codigoHex2}`}} className="hex--inner"></span>}
                                </span>
                                <span className="name">{pColor.color}</span>
                            </button>
                        );
                    })}
                </div>
                <div>
                    {defaultUrl && <img src={defaultUrl} alt="" className="mobile" style={ANIMATIONS.fadeIn} />}
                </div>
            </div>
        </div>
    );
};
const Color = ({ match, personalization }) => {
    const { tipo, modelo, version, anio } = match.params;
    const [color, setColor] = useState({});
    useEffect(() => {
        if (personalization.isLoading || !personalization.data) return;

        const initialColor = personalization?.data?.colors[0] || {};
        setColor(initialColor);
    }, [personalization, personalization.isLoading]);
    const colors = personalization?.data?.colors || [];

    const styles = {
        // bounce: {
        //   animation: 'x 1s',
        //   animationName: Radium.keyframes(bounce, 'bounce'),
        // },
        fadeIn: {
          animation: 'x 1s',
          animationName: Radium.keyframes(fadeIn, 'fadeIn'),
        },
      };
    const showEntrega = personalization?.data?.mostrarFechaEntrega === "1";
    return (
        <StyleRoot>
            <PersonalizationContainer
                className="color-personalization"
                isLoading={color?.imageGrande && personalization.isLoading}
                carUrl={color?.imageGrande}
                leftPanel={
                    <ColorsList 
                        personalization={personalization}
                        colors={colors}
                        color={color} 
                        setColor={setColor}
                        styles={styles}
                        className="desktop"
                    />
                }
                leftMobilePanel={
                    <ColorsList 
                        personalization={personalization}
                        colors={colors}
                        color={color} 
                        setColor={setColor}
                        styles={styles}
                        className="mobile"
                    />
                }
                rightPanel={
                    (showEntrega && <Entrega color={color} />)
                }
                title="Escoge tu color" 
                subTitle="Nada mejor que recibir tu carro nuevo, del color que más va con vos. No lo pensés más y ordená tus accesorios de una vez.">
                <div className="color">
                    <div className="extras__navigation">
                        <NavigationBar
                            back={`/${tipo}/${modelo}/`}
                            next={`/${tipo}/${modelo}/${version}/${anio}/${(color?.colorDesc || '').toLowerCase()}/accesorios/`}
                        />
                    </div>
                </div>
            </PersonalizationContainer>
        </StyleRoot>
    );
};

export default withRouter(Color);
